(function () {
  function init(root) {
    if (root.dataset.urbPolkaReady === '1') return;
    root.dataset.urbPolkaReady = '1';

    var tablist = root.querySelector('[data-urb-polka-tabs]');
    if (!tablist) return;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('.urb-polka__tab'));
    var button = root.querySelector('[data-urb-polka-button]');
    var fallback = button ? button.getAttribute('href') : '';

    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && button) {
          var url = tab.getAttribute('data-urb-polka-url');
          button.setAttribute('href', url ? url : fallback);
        }
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        activate(next, true);
      });
    });

    activate(0, false);
  }

  function boot() {
    document.querySelectorAll('[data-urb-polka]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-urb-polka]');
    if (root) init(root);
  });
})();
